import { useLayoutEffect, useRef, useState } from 'react';
import './styles.scss';

type toggleWidthType = {
  toggleA: number;
  toggleB: number;
};

type option = string | number;

interface ISwitchProps {
  options: {
    a: option;
    b: option;
  };
  onToggle(): void;
  toggle: boolean;
  textSize: number;
  initialOptionWidth?: number;
  gap?: number;
}

const Switch = ({
  options,
  onToggle,
  toggle,
  textSize,
  initialOptionWidth = 9,
  gap = 20,
}: ISwitchProps) => {
  const [toggleWidth, setToggleWidth] = useState<toggleWidthType>({
    toggleA: initialOptionWidth,
    toggleB: initialOptionWidth,
  });
  const optionA = useRef<HTMLSpanElement>(null);
  const optionB = useRef<HTMLSpanElement>(null);

  useLayoutEffect(() => {
    if (optionA.current && optionB.current) {
      setToggleWidth({
        toggleA: optionA.current.clientWidth,
        toggleB: optionB.current.clientWidth,
      });
    }
  }, []);

  return (
    <div className='switch' style={{gap}}>
      <input
        type='checkbox'
        id='toggle_switch'
        checked={toggle}
        onChange={onToggle}
      />
      <div
        className='switch__toggle_a'
        style={{
          width: !toggle ? `${19 + toggleWidth?.toggleA}px` : '100%',
        }}
      />
      <div
        className='switch__toggle_b'
        style={{
          width: toggle ? `${19 + toggleWidth?.toggleB}px` : '100%',
        }}
      />
      <span
        className={`text text--${textSize} text--white switch__option ${
          !toggle ? 'text--grey-200' : 'text--grey-600'
        }`}
        ref={optionA}
      >
        {options.a}
      </span>
      <span
        className={`text text--${textSize} text--white switch__option ${
          toggle ? 'text--grey-200' : 'text--grey-600'
        }`}
        ref={optionB}
      >
        {options.b}
      </span>
      <label htmlFor='toggle_switch' className='switch__label' />
    </div>
  );
};

export default Switch;
